import 'core-js/es6/object';
import Video from '@bbc/news-vj-component-video';


export default function Paper(wrapper) {
    Video({ vpid: __('smp_46-pid'), scope: wrapper.scope });
    Video({ vpid: __('smp_58-pid'), scope: wrapper.scope });
    Video({ vpid: __('smp_64-pid'), scope: wrapper.scope });
    return wrapper;
}

